export const BUTTON_HEIGHT = 40

export const MAX_WIDTH_FOR_FIRST_ROW = 660

export const GAP_SIZE = 8

export const INIT_MAX_SHOW_COUNT = 3

export const MAX_DROPDOWN_HEIGHT = 352
